import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';

const PAGE_SIZE = 50;

function formatCell(value) {
    if (value == null) return '';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}

function ReportPreviewTable({ reportName, preview }) {
    const [page, setPage] = useState(0);

    useEffect(() => setPage(0), [preview]);

    const rows = preview.rows || [];
    const pageCount = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
    const pageRows = rows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
    const firstRow = page * PAGE_SIZE + 1;
    const lastRow = Math.min((page + 1) * PAGE_SIZE, rows.length);

    return (
        <Card className="pharmacy-reports-card">
            <CardBody>
                <div className="pharmacy-reports-preview-header">
                    <h4 className="pharmacy-reports-preview-title">{reportName}</h4>
                    <span className="pharmacy-reports-preview-count">
                        {rows.length} {rows.length === 1 ? 'row' : 'rows'}
                    </span>
                </div>

                {rows.length === 0 ? (
                    <div className="pharmacy-reports-preview-empty">No data found for the selected filters.</div>
                ) : (
                    <>
                        <div className="pharmacy-reports-preview-wrapper">
                            <table className="pharmacy-reports-preview-table">
                                <thead>
                                    <tr>
                                        {(preview.columns || []).map((column, index) => (
                                            <th key={index}>{column}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageRows.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {row.map((value, cellIndex) => {
                                                const text = formatCell(value);
                                                return (
                                                    <td key={cellIndex}>
                                                        {text === '' ? (
                                                            <span className="pharmacy-reports-preview-empty-cell">—</span>
                                                        ) : (
                                                            text
                                                        )}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="pharmacy-reports-preview-footer">
                            <span className="text-muted">
                                Showing {firstRow}–{lastRow} of {rows.length}
                            </span>
                            {pageCount > 1 && (
                                <div className="pharmacy-reports-preview-pagination">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        disabled={page === 0}
                                        onClick={() => setPage(page - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span className="text-muted">
                                        Page {page + 1} of {pageCount}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        disabled={page === pageCount - 1}
                                        onClick={() => setPage(page + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </CardBody>
        </Card>
    );
}

export default ReportPreviewTable;
